// extracted by mini-css-extract-plugin
export default {"-large":"grid-email-campaign-audience-item-module__-large--ECjJl","audienceGridItem":"grid-email-campaign-audience-item-module__audienceGridItem--gvz3L"};